import { AdminApiProxiedService } from '../services';
import type { OrganizationSecretSetRequest } from '../services';

export type { OrganizationSecretSetRequest };
export type { OrganizationSecretResponse } from '../services';

export const getOrganizationSecrets = () => {
  return AdminApiProxiedService.listOrganizationSecretsAdminOrganizationSecretsGet();
};

export const getOrganizationSecret = (keyName: string) => {
  return AdminApiProxiedService.getOrganizationSecretAdminOrganizationSecretsKeyNameGet(
    keyName
  );
};

export const setOrganizationSecret = (
  keyName: string,
  payload: OrganizationSecretSetRequest
) => {
  return AdminApiProxiedService.setOrganizationSecretAdminOrganizationSecretsKeyNamePut(
    keyName,
    payload
  );
};

export const deleteOrganizationSecret = (keyName: string) => {
  return AdminApiProxiedService.deleteOrganizationSecretAdminOrganizationSecretsKeyNameDelete(
    keyName
  );
};
